module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "Home"
  }, [_c('section', {
    staticClass: "Home_intro has-text-centered"
  }, [_c('nav', {
    staticClass: "navbar is-transparent"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo_small.svg"),
      "alt": "The Warmup"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button navbar-burger is-transparent is-flat",
    on: {
      "click": function($event) {
        _vm.menu_open = !_vm.menu_open
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end navbar-menu",
    class: {
      'is-active': _vm.menu_open
    }
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#what',
        offset: 20
      }),
      expression: "{el: '#what', offset: 20}"
    }],
    staticClass: "navbar-item",
    on: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_vm._v("\n          Qu'est-ce que c'est ?\n        ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '#lastest-hits',
        offset: 20
      }),
      expression: "{el: '#lastest-hits', offset: 20}"
    }],
    staticClass: "navbar-item",
    on: {
      "click": function($event) {
        _vm.menu_open = false
      }
    }
  }, [_vm._v("\n          Les derniers hits des players\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    staticClass: "button is-outlined is-danger is-flat",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("\n            Se connecter\n          ")])], 1)])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-size-4-touch is-size-2-desktop"
  }, [_vm._v("Le terrain d'entraînement des étudiants du digital")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "Home_cta"
  }, [_c('router-link', {
    staticClass: "button is-warning",
    attrs: {
      "to": {
        name: 'register'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$trackEventBasic('Home', 'click register', 'intro')
      }
    }
  }, [_vm._v("\n        Inscris-toi\n      ")])], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "Home_hits",
    attrs: {
      "id": "lastest-hits"
    }
  }, [_c('h2', {
    staticClass: "title is-size-3-desktop is-size-5-touch has-text-centered"
  }, [_vm._v("Les derniers hits des players")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.hits), function(hit) {
    return _c('div', {
      key: hit.id,
      staticClass: "column is-half"
    }, [_c('hit-card', {
      attrs: {
        "player": hit.player,
        "hit": hit,
        "is-public": true,
        "show-date": false
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "Home_cta has-text-centered"
  }, [_c('router-link', {
    staticClass: "button is-warning",
    attrs: {
      "to": {
        name: 'register'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$trackEventBasic('Home', 'click register', 'latest hits')
      }
    }
  }, [_vm._v("\n        Inscris-toi\n      ")])], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "Home_footer has-text-centered"
  }, [_vm._m(3), _vm._v(" "), _c('h2', {
    staticClass: "title is-size-3-desktop is-size-5-touch"
  }, [_vm._v("The Warmup, l'échauffement commence ici !")]), _vm._v(" "), _c('p', [_vm._v("Rejoins tous les étudiants qui font partie du game")]), _vm._v(" "), _c('div', {
    staticClass: "Home_cta"
  }, [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": {
        name: 'register'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$trackEventBasic('Home', 'click register', 'footer')
      }
    }
  }, [_vm._v("\n        Inscris-toi\n      ")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "is-size-7-mobile"
  }, [_vm._v("\n      Tu es étudiant en digital ou en multimédia ? "), _c('br'), _vm._v(" Partage tes réalisations et améliore-toi grâce aux feedbacks des autres étudiants.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Home_schools"
  }, [_c('figure', {
    staticClass: "Home_schools_preview"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/app-preview.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Home_schools_content"
  }, [_c('h2', [_vm._v("Déjà plusieurs écoles disponibles")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/schools/hetic.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/schools/eemi.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/schools/epitech.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/schools/efreitech.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/img/schools/webschool_factory.jpg")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Home_what has-text-centered",
    attrs: {
      "id": "what"
    }
  }, [_c('h2', {
    staticClass: "title is-size-3-desktop is-size-5-touch"
  }, [_vm._v("The Warmup, c'est une plateforme pour...")]), _vm._v(" "), _c('div', {
    staticClass: "columns content"
  }, [_c('article', {
    staticClass: "column"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/illus/share.png")
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Partager tes réalisations")]), _vm._v(" "), _c('p', [_vm._v("\n          Code, vidéo, design ou toute autre réalisation numérique sont partagés avec une communauté d'étudiants venant de diverses écoles.\n        ")])]), _vm._v(" "), _c('article', {
    staticClass: "column"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/illus/feedback.png")
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Obtenir des feedbacks")]), _vm._v(" "), _c('p', [_vm._v("\n          Tous les players, quelles que soient leurs spécialisations et leurs compétences, te font des feedbacks et te laissent des commentaires.\n        ")])]), _vm._v(" "), _c('article', {
    staticClass: "column"
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/illus/cards.png")
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Progresser")]), _vm._v(" "), _c('p', [_vm._v("\n          Grâce à la communauté, tu t'améliores et tu montes en compétence. Leurs commentaires sont le meilleur moyen pour toi de progresser !\n        ")])])]), _vm._v(" "), _c('figure', {
    staticClass: "Home_what_illus columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/catcher.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/illu-2.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/illu-1.png")
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": require("../assets/img/big-logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3990ed6d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHome.vue
// module id = 356
// module chunks = 9